import JustFoRole from "./JustFoRole";

const JustForCustomer = JustFoRole("customer");

export default JustForCustomer;
